export default "__VITE_ASSET__CUzgIeHn__"